module.exports = __webpack_public_path__ + "img/tn-stock-5.a97c0a7c.jpeg";